export enum EbookSalesAnalyticsDetailReportEnum {
  SALES = 'SALES',
  PURCHASE_COUNT = 'PURCHASE_COUNT',
  PROMOTION = 'PROMOTION',
  VIEW = 'VIEW',
  READ_TRIAL_CHAPTERS = 'READ_TRIAL_CHAPTERS',
}
